export const MEDIA_WIDTH = 480;
export const MEDIA_HEIGHT = 720;